import React, { Component } from 'react';
import debounce from 'lodash/debounce';

export default class ImageRefresher extends Component {
  constructor(props) {
    super(props);
    this.state.imageUrl = props.imageUrl;
    this.updateImage = debounce(this.update, 70);
  }

  state = {
    // loadImage: true,
    imageUrl: null
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.imageUrl !== this.props.imageUrl) {
      this.state.imageUrl = null;
      this.updateImage(nextProps.imageUrl);
    }
  }

  update = (imageUrl) => {
    this.setState({
      imageUrl
    });
  };

  render() {
    return this.props.children(this.state.imageUrl);
  }
}
